// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--3A712","logo":"header-module--logo--dkMqu","icon":"header-module--icon--2m3R9","text":"header-module--text--226XQ"};